import React from "react";
import closeIcon from "../../include/images/dark-close-icon.svg";
import { imageUrl } from "../../actions/miscAction";
const alertIcon = imageUrl("check-icons.svg");
const AlertSuccess = (props) => {
  return (
    <div class="alert-container">
      <div
        class="alert alert-success alert-white"
        style={{
          border: "2px solid #f5f5f5",
          boxShadow: "0px 6px 20px 0px #0000001a",
        }}
      >
        <span class="alert-icon">
          <i>
            <img src={alertIcon} alt="alert" />
          </i>
        </span>
        <p>{props.message}</p>
        <span class="alert-right">
          <a class="alert-close" data-bs-dismiss="alert">
            <img src={closeIcon} alt="close" />
          </a>
        </span>
      </div>
    </div>
  );
};

export default AlertSuccess;
